import React, { useMemo } from 'react';
import { Heading, Text, colors } from '@web-for-marketing/react-ui';
import { useAtom } from 'jotai';
import { selectedLanguageAtom } from '@atoms/appSettings';
import { getTranslation } from '@helpers/languageTranslations';
import { useTranslation } from '@stateManagement/TranslationContext';
import { ExternalResourceLink } from '@models/externalResourceLink';
import { getFormattedLocalDateTime } from '@helpers/dates';
import { Divider, Stack } from '@mui/material';
import { PublicDateTime } from '@components/PublicDateTime';

const classes = {
    paddingContainer: {
        padding: '3.2rem',
        backgroundColor: colors.background.lighter,
        borderRadius: '0.8rem',
    },
    link: {
        textDecoration: 'none',
        '&:hover': {
            textDecoration: 'underline',
        },
    },
} as const;

interface MediaReleaseIntheNewsProps {
    intheNews: ExternalResourceLink[];
}

export function MediaReleaseIntheNews({ intheNews }: MediaReleaseIntheNewsProps): React.ReactElement {
    const { selectedLanguageTranslation } = useTranslation();
    const [selectedLanguage] = useAtom(selectedLanguageAtom);

    const inTheNewsTranslation = useMemo(() => {
        return getTranslation(selectedLanguageTranslation, 'pressRelease', 'inTheNews');
    }, [selectedLanguageTranslation]);

    return (
        <Stack gap={3} css={classes.paddingContainer}>
            <Heading variant='h3' weight='bold'>
                {inTheNewsTranslation}
            </Heading>
            <Divider />
            {intheNews && intheNews.length > 0 ? (
                <Stack gap={4}>
                    {intheNews.map(({ link, title, publishedDateUtc, id }) => (
                        <Stack gap={1} alignItems='flex-start' textOverflow='ellipsis' key={id}>
                            <Text
                                component='a'
                                variant='h5'
                                weight='bold'
                                color='activePrimary'
                                href={link}
                                target='_blank'
                                css={classes.link}
                            >
                                {title}
                            </Text>
                            <PublicDateTime>
                                <Text variant='body2'>
                                    {getFormattedLocalDateTime(publishedDateUtc, 'LL', selectedLanguage)}
                                </Text>
                            </PublicDateTime>

                        </Stack>
                    ))}
                </Stack>
            ) : null}
        </Stack>
    );
}
